import { RouteRecordRaw } from 'vue-router'

/**
 * 文本处理模块的子路由配置
 * 所有路由都会自动加上 /textprocess 前缀
 */
const textProcessRoutes: Array<RouteRecordRaw> = [
  {
    // 文本处理模块首页
    path: '',
    name: 'TextProcessHome',
    component: () => import('../views/TextProcessHome.vue'),
    meta: {
      title: '文本处理'
    }
  },
  {
    // 替换文本
    path: 'replace',
    name: 'TextReplace',
    component: () => import('../views/Replace/ReplacePage.vue'),
    meta: {
      title: '替换文本',
      parent: '文本处理'
    }
  }
  // 未来可以在这里添加更多子功能
  // {
  //   path: 'extract',
  //   name: 'TextExtract',
  //   component: () => import('../views/Extract/ExtractPage.vue'),
  //   meta: {
  //     title: '提取文本',
  //     parent: '文本处理'
  //   }
  // }
]

export default textProcessRoutes
